<div #toolTipContainerRef class="tooltip-container" (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
  <ng-content></ng-content>
</div>
<ng-template #tooltipTemplate>
  <div class="holder" [ngClass]="position">
    <div class="tooltip-text" [ngStyle]="{ backgroundColor: bgColor }">
      {{ text }}
    </div>
  </div>
</ng-template>
